import { loadJSON, saveJSON } from "./storage";
var ColorScheme;
(function (ColorScheme) {
    ColorScheme["LIGHT"] = "LIGHT";
    ColorScheme["DARK"] = "DARK";
    ColorScheme["AUTO"] = "AUTO";
})(ColorScheme || (ColorScheme = {}));
const defaultSettings = {
    colorScheme: ColorScheme.AUTO,
    autoNewQuestion: true,
    autoNewQuestionTimeout: 2000
};
const storageKey = "settings";
function loadSettings() {
    const savedSettings = loadJSON(storageKey);
    return Object.assign(Object.assign({}, defaultSettings), savedSettings);
}
function saveSettings(settings) {
    saveJSON(storageKey, settings);
}
function setColorScheme(settings, value) {
    const newSettings = Object.assign(Object.assign({}, settings), { colorScheme: value });
    saveSettings(newSettings);
    return newSettings;
}
function setAutoNewQuestion(settings, value) {
    const newSettings = Object.assign(Object.assign({}, settings), { autoNewQuestion: value });
    saveSettings(newSettings);
    return newSettings;
}
function setAutoNewQuestionTimeout(settings, value) {
    const newSettings = Object.assign(Object.assign({}, settings), { autoNewQuestionTimeout: value });
    saveSettings(newSettings);
    return newSettings;
}
const colorSchemes = [ColorScheme.LIGHT, ColorScheme.DARK, ColorScheme.AUTO];
export { loadSettings, setColorScheme, setAutoNewQuestion, setAutoNewQuestionTimeout, colorSchemes, ColorScheme };
